(function () {
  if (
    typeof window.gsap === "undefined" ||
    typeof window.Draggable === "undefined"
  ) {
    console.warn("[AlbumSlider] GSAP or Draggable is missing.");
    return;
  }

  const gsap = window.gsap;
  gsap.registerPlugin(window.Draggable);

  function initAlbumSlider(section) {
    const gallery = section.querySelector(".gallery");
    const cards = gsap.utils.toArray(
      section.querySelectorAll(".cards .album-card"),
    );
    const cardInners = gsap.utils.toArray(
      section.querySelectorAll(".album-card__inner"),
    );
    const cardFronts = gsap.utils.toArray(
      section.querySelectorAll(".album-card__front"),
    );
    const cardSides = gsap.utils.toArray(
      section.querySelectorAll(".album-card__side"),
    );

    const dragProxy = section.querySelector(".drag-proxy");
    const nextButton = section.querySelector(".next");
    const prevButton = section.querySelector(".prev");

    const cursorLabel = section.querySelector(".album-cursor-label");
    const cursorLabelTitle = cursorLabel?.querySelector(
      ".album-cursor-label__title",
    );
    const cursorLabelYear = cursorLabel?.querySelector(
      ".album-cursor-label__year",
    );

    const mobileInfo = section.querySelector(".album-mobile-info");
    const mobileInfoTitle = mobileInfo?.querySelector(
      ".album-mobile-info__title",
    );
    const mobileInfoYear = mobileInfo?.querySelector(
      ".album-mobile-info__year",
    );

    if (!gallery || !cards.length || !dragProxy) return;
    if (section.dataset.albumSliderInitialized === "true") return;
    section.dataset.albumSliderInitialized = "true";

    const hoverState = cards.map(() => ({ offsetX: 0 }));
    const fadeState = cards.map(() => ({ opacityMult: 1 }));

    let position = 0;
    let targetPosition = 0;
    let hoveredCardIndex = -1;

    let isTransitioning = false;
    let transitionCardIndex = -1;

    const followEase = 0.12;
    const wheelStrength = 0.0032;
    const hoverOffset = 50;

    const mouse = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    const labelPos = { x: mouse.x, y: mouse.y };

    const labelFollowEase = 0.14;
    const labelOffsetX = 28;
    const labelOffsetY = 24;

    const slots = [
      { x: -1300, y: 500, z: 1200, rotateY: -25, scale: 1.0, opacity: 0.78 },
      { x: -1080, y: 430, z: 980, rotateY: -25, scale: 1.0, opacity: 0.82 },
      { x: -860, y: 330, z: 760, rotateY: -25, scale: 1.0, opacity: 0.86 },
      { x: -600, y: 210, z: 480, rotateY: -25, scale: 1.0, opacity: 0.9 },
      { x: -320, y: 90, z: 180, rotateY: -25, scale: 1.0, opacity: 0.96 },

      { x: 0, y: -10, z: 0, rotateY: -25, scale: 1.0, opacity: 1.0 },

      { x: 300, y: -90, z: -180, rotateY: -25, scale: 1.0, opacity: 0.96 },
      { x: 640, y: -220, z: -480, rotateY: -25, scale: 1.0, opacity: 0.9 },
      { x: 1000, y: -360, z: -760, rotateY: -25, scale: 1.0, opacity: 0.86 },
      { x: 1350, y: -500, z: -980, rotateY: -25, scale: 1.0, opacity: 0.82 },
      { x: 1700, y: -620, z: -1200, rotateY: -25, scale: 1.0, opacity: 0.78 },
    ];

    const slotCenter = Math.floor(slots.length / 2);

    function isMobileView() {
      return window.innerWidth <= 749;
    }

    function lerp(a, b, t) {
      return a + (b - a) * t;
    }

    function interpolateSlot(a, b, t) {
      return {
        x: lerp(a.x, b.x, t),
        y: lerp(a.y, b.y, t),
        z: lerp(a.z, b.z, t),
        rotateY: lerp(a.rotateY, b.rotateY, t),
        scale: lerp(a.scale, b.scale, t),
        opacity: lerp(a.opacity, b.opacity, t),
      };
    }

    function getWrappedRelative(cardIndex, baseIndex, total) {
      let diff = cardIndex - baseIndex;
      diff = ((diff % total) + total) % total;

      if (diff > total / 2) {
        diff -= total;
      }

      return diff;
    }

    function getShortestStepToCard(cardIndex) {
      const currentIndex = Math.round(position);
      const total = cards.length;

      let diff = cardIndex - currentIndex;
      diff = ((diff + total / 2) % total) - total / 2;

      return diff;
    }

    let mobileFocusedIndex = -1;

    function updateMobileFocusedAlbum() {
      if (!mobileInfo || !mobileInfoTitle || !mobileInfoYear) return;
      if (!isMobileView()) return;
      if (!cards.length) return;

      const focusedIndex =
        ((Math.round(position) % cards.length) + cards.length) % cards.length;

      if (focusedIndex === mobileFocusedIndex) return;
      mobileFocusedIndex = focusedIndex;

      const focusedCard = cards[focusedIndex];
      if (!focusedCard) return;

      const nextTitle = focusedCard.dataset.title || "";
      const nextYear = focusedCard.dataset.year || "";

      gsap.killTweensOf([mobileInfoTitle, mobileInfoYear]);

      const tl = gsap.timeline();

      tl.to([mobileInfoTitle, mobileInfoYear], {
        y: -10,
        opacity: 0,
        duration: 0.16,
        ease: "power2.out",
        stagger: 0.03,
      });

      tl.call(() => {
        mobileInfoTitle.textContent = nextTitle;
        mobileInfoYear.textContent = nextYear;

        gsap.set([mobileInfoTitle, mobileInfoYear], {
          y: 10,
          opacity: 0,
        });
      });

      tl.to([mobileInfoTitle, mobileInfoYear], {
        y: 0,
        opacity: 1,
        duration: 0.22,
        ease: "power2.out",
        stagger: 0.04,
      });
    }

    function showCursorLabel(cardIndex) {
      if (!cursorLabel || !cursorLabelTitle || !cursorLabelYear) return;
      if (cardIndex < 0 || !cards[cardIndex]) return;

      const card = cards[cardIndex];
      const title = card.dataset.title || "";
      const year = card.dataset.year || "";

      cursorLabelTitle.textContent = title;
      cursorLabelYear.textContent = year;
      cursorLabel.classList.add("is-visible");
    }

    function hideCursorLabel() {
      if (!cursorLabel) return;
      cursorLabel.classList.remove("is-visible");
    }

    function setHoveredCard(nextIndex) {
      if (hoveredCardIndex === nextIndex) return;

      if (hoveredCardIndex !== -1) {
        gsap.to(hoverState[hoveredCardIndex], {
          offsetX: 0,
          duration: 0.22,
          ease: "power2.out",
          overwrite: true,
        });
      }

      hoveredCardIndex = nextIndex;

      if (hoveredCardIndex !== -1) {
        gsap.to(hoverState[hoveredCardIndex], {
          offsetX: hoverOffset,
          duration: 0.22,
          ease: "power2.out",
          overwrite: true,
        });

        showCursorLabel(hoveredCardIndex);
      } else {
        hideCursorLabel();
      }
    }

    function render() {
      const baseIndex = Math.floor(position);
      const progress = position - baseIndex;

      cards.forEach((card, cardIndex) => {
        if (isTransitioning && cardIndex === transitionCardIndex) {
          return;
        }

        const relative = getWrappedRelative(cardIndex, baseIndex, cards.length);
        const visualPosition = relative - progress;

        const slotPos = visualPosition + slotCenter;
        const slotIndexA = Math.floor(slotPos);
        const slotIndexB = slotIndexA + 1;
        const t = slotPos - slotIndexA;

        if (slotIndexA < 0 || slotIndexB >= slots.length) {
          gsap.set(card, {
            opacity: 0,
            scale: 0.6,
            z: -700,
            rotateY: -25,
            pointerEvents: "none",
          });
          return;
        }

        const interpolated = interpolateSlot(
          slots[slotIndexA],
          slots[slotIndexB],
          t,
        );

        gsap.set(card, {
          x: interpolated.x + hoverState[cardIndex].offsetX,
          y: interpolated.y,
          z: interpolated.z,
          rotateY: interpolated.rotateY,
          rotateX: 0,
          rotateZ: 0,
          scale: interpolated.scale,
          opacity: interpolated.opacity * fadeState[cardIndex].opacityMult,
          zIndex:
            1000 -
            Math.round(Math.abs(visualPosition) * 20) +
            Math.round(interpolated.z * 0.01),
          pointerEvents: "auto",
          transformOrigin: "50% 50%",
          backfaceVisibility: "hidden",
        });
      });
    }

    function tick() {
      const diff = targetPosition - position;

      if (Math.abs(diff) >= 0.0001) {
        position += diff * followEase;
      }

      render();
      updateMobileFocusedAlbum();

      if (cursorLabel) {
        labelPos.x += (mouse.x - labelPos.x) * labelFollowEase;
        labelPos.y += (mouse.y - labelPos.y) * labelFollowEase;

        gsap.set(cursorLabel, {
          x: labelPos.x + labelOffsetX,
          y: labelPos.y + labelOffsetY,
        });
      }
    }

    function onWheel(event) {
      if (isTransitioning) return;
      event.preventDefault();
      targetPosition += event.deltaY * wheelStrength;
    }

    function transitionToAlbum(cardIndex) {
      if (isTransitioning) return;

      const card = cards[cardIndex];
      const link = card?.dataset.link;
      if (!card || !link) return;

      isTransitioning = true;
      transitionCardIndex = cardIndex;
      setHoveredCard(-1);

      const stepDiff = getShortestStepToCard(cardIndex);
      const destination = Math.round(position) + stepDiff;

      const tl = gsap.timeline({
        onComplete: () => {
          window.location.href = link;
        },
      });

      cards.forEach((otherCard, index) => {
        if (index !== cardIndex) {
          tl.to(
            fadeState[index],
            {
              opacityMult: 0,
              duration: 0.28,
              ease: "power2.out",
            },
            0,
          );
        }
      });

      tl.to(
        { value: targetPosition },
        {
          value: destination,
          duration: 0.55,
          ease: "power3.inOut",
          onUpdate: function () {
            targetPosition = this.targets()[0].value;
            position = this.targets()[0].value;
          },
          onComplete: () => {
            position = destination;
            targetPosition = destination;
          },
        },
        0.2,
      );

      tl.to(
        card,
        {
          x: 0,
          y: 0,
          z: 0,
          rotateY: 0,
          rotateX: 0,
          rotateZ: 0,
          scale: 1,
          opacity: 1,
          duration: 0.38,
          ease: "power3.inOut",
        },
        0.65,
      );

      const side = card.querySelector(".album-card__side");
      if (side) {
        tl.to(
          side,
          {
            opacity: 0,
            duration: 0.6,
            ease: "power2.out",
          },
          0.65,
        );
      }
    }

    gsap.set(gallery, { perspective: 2000 });
    gsap.set(section.querySelector(".cards"), {
      transformStyle: "preserve-3d",
    });

    gsap.set(cards, {
      xPercent: -50,
      yPercent: -50,
      rotateY: -25,
      rotateX: 0,
      rotateZ: 0,
      transformStyle: "preserve-3d",
    });

    gsap.set(cardInners, {
      transformStyle: "preserve-3d",
    });

    gsap.set(cardFronts, {
      pointerEvents: "none",
      backfaceVisibility: "hidden",
    });

    gsap.set(cardSides, {
      pointerEvents: "none",
      backfaceVisibility: "hidden",
    });

    render();
    updateMobileFocusedAlbum();
    gsap.ticker.add(tick);
    window.addEventListener("wheel", onWheel, { passive: false });

    nextButton?.addEventListener("click", () => {
      if (isTransitioning) return;
      targetPosition = Math.round(position) + 1;
    });

    prevButton?.addEventListener("click", () => {
      if (isTransitioning) return;
      targetPosition = Math.round(position) - 1;
    });

    window.Draggable.create(dragProxy, {
      type: "x",
      trigger: gallery,
      onPress() {
        if (isTransitioning) return false;
        this.startTarget = targetPosition;
      },
      onDrag() {
        if (isTransitioning) return;
        targetPosition = this.startTarget + (this.startX - this.x) * 0.01;
      },
    });

    gallery.addEventListener("mousemove", (event) => {
      mouse.x = event.clientX;
      mouse.y = event.clientY;

      if (isTransitioning) return;
      if (isMobileView()) return;

      const mouseX = event.clientX;
      const mouseY = event.clientY;

      let bestIndex = -1;
      let bestScore = Infinity;

      cards.forEach((card, index) => {
        const style = window.getComputedStyle(card);

        if (style.pointerEvents === "none" || Number(style.opacity) < 0.05) {
          return;
        }

        const rect = card.getBoundingClientRect();

        if (
          mouseX >= rect.left &&
          mouseX <= rect.right &&
          mouseY >= rect.top &&
          mouseY <= rect.bottom
        ) {
          const centerX = rect.left + rect.width / 2;
          const centerY = rect.top + rect.height / 2;

          const dx = mouseX - centerX;
          const dy = mouseY - centerY;
          const score = dx * dx + dy * dy;

          if (score < bestScore) {
            bestScore = score;
            bestIndex = index;
          }
        }
      });

      setHoveredCard(bestIndex);
    });

    gallery.addEventListener("mouseleave", () => {
      if (isTransitioning) return;
      if (isMobileView()) return;
      setHoveredCard(-1);
    });

    gallery.addEventListener("click", (event) => {
      if (isTransitioning) return;

      if (isMobileView()) {
        const focusedIndex =
          ((Math.round(position) % cards.length) + cards.length) % cards.length;
        transitionToAlbum(focusedIndex);
        return;
      }

      if (hoveredCardIndex !== -1) {
        transitionToAlbum(hoveredCardIndex);
      }
    });

    function onPageShow(event) {
      if (!event.persisted) return;

      isTransitioning = false;
      transitionCardIndex = -1;
      hoveredCardIndex = -1;
      fadeState.forEach((s) => { s.opacityMult = 1; });
      hoverState.forEach((s) => { s.offsetX = 0; });
      hideCursorLabel();
      render();
    }

    window.addEventListener("pageshow", onPageShow);

    document.addEventListener(
      "shopify:section:unload",
      function onUnload(event) {
        if (!event.target || event.target !== section) return;

        window.removeEventListener("wheel", onWheel);
        window.removeEventListener("pageshow", onPageShow);
        gsap.ticker.remove(tick);
        section.dataset.albumSliderInitialized = "false";
        document.removeEventListener("shopify:section:unload", onUnload);
      },
    );
  }

  function initAllAlbumSliders() {
    document.querySelectorAll(".album-slider-section").forEach(initAlbumSlider);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllAlbumSliders);
  } else {
    initAllAlbumSliders();
  }

  document.addEventListener("shopify:section:load", function (event) {
    const section =
      event.target?.querySelector(".album-slider-section") || event.target;

    if (section && section.classList?.contains("album-slider-section")) {
      initAlbumSlider(section);
    }
  });
})();
